<script>
import RawData from "@/components/widgets/raw-data.vue";
export default {
  name: "ModificationItemModal",
  components: {
    RawData,
  },
  data(){
    return {
        tableData: [],
        filter: "",
        perPage: 10,
        currentPage: 1,
        pageOptions: [10, 25, 50, 100],
    }
  },
  computed: {
    filtered(){
        let data = this.tableData;
        var total = this.currentPage * this.perPage;
        if (this.filter.trim() != "" && this.filter) {
            data = data.filter((item) => {
                return item.filterKey
                    .toUpperCase()
                    .includes(this.filter.toUpperCase());
            });
        }
        var currentData = data.slice(total - this.perPage, total);
        if (this.currentPage > 1 && currentData.length == 0) {
            total = (this.currentPage - 1) * this.perPage;
            currentData = data.slice(total - this.perPage, total);
        }
        return currentData;
    },
    rows(){
        let data = this.tableData;
        if (this.filter.trim() != "" && this.filter) {
            data = data.filter((item) => {
                return item.filterKey
                    .toUpperCase()
                    .includes(this.filter.toUpperCase());
            });
        }
        return data.length;
    },
  },
  methods: {
    setItems(items){
        this.tableData = items;
    },
  }
}
</script>

<template>
    <b-modal
        id="modif-items-modal"
        title="Modification Items"
        size="lg"
        title-class="font-18"
        hide-footer
        no-close-on-backdrop
    >
        <div class="mb-2">
            <div class="d-flex align-items-center justify-content-between">
                <label
                    class="d-inline-flex align-items-center mb-0 me-1"
                >
                    <b-form-input
                        autocomplete="off"
                        v-model="filter"
                        type="search"
                        placeholder="Search Item Resources..."
                        class="form-control"
                        style="width: 300px;"
                    ></b-form-input>
                    <b-form-select
                        class="form-select ms-1 w-25"
                        v-model="perPage"
                        :options="pageOptions"
                    ></b-form-select>
                </label>
            </div>
        </div>
        <div>
            <template v-for="x in filtered">
                <template v-for="y in x.realignmentRequestItems">
                    <div class="d-flex align-items-center justify-content-between px-2 py-2 border-bottom position-relative" :key="y.id">
                        <RawData :data="y" v-if="$store.state.decrypt.isAdmin()" />
                        <div class="d-flex">
                            <div class="d-flex align-items-center">
                                <div class="font-size-20 text-yellow"> {{y.quantity}} </div>
                                <i class="bx bx-x font-size-20 me-2 text-yellow"></i>
                            </div>
                            <div>
                                <div> 
                                    {{y.apiResourceDetail.apiResource.itemName}} 
                                    <div>
                                        <small>{{y.apiResourceDetail.apiResource.description}}</small>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="text-center">
                            <div class="
                                font-size-18
                                text-yellow
                                mb-0
                            "> {{formatCurrency(y.total)}}
                            </div>
                            <div>
                                <small> ({{formatCurrency(y.apiResourceDetail.apiResource.inflatedUnitCost)}}) </small>
                            </div>
                        </div>
                    </div>
                </template>
            </template>
            <div class="row my-3">
                <div class="col">
                    <div
                        class="
                            dataTables_paginate
                            paging_simple_numbers
                            float-end
                        "
                    >
                        <ul
                            class="
                                pagination pagination-rounded
                                mb-0
                            "
                        >
                            <b-pagination
                                v-model="currentPage"
                                :total-rows="rows"
                                :per-page="perPage"
                            ></b-pagination>
                        </ul>
                    </div>
                </div>
            </div>
        </div>
    </b-modal>
</template>